import React from 'react';
import { Button } from '../ui/Button';
import { ShieldCheckIcon, DownloadIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-stone-900 text-white relative overflow-hidden" data-id="element-128">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-orange-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-129"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-130">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8" data-id="element-131">
          Recupera tu dignidad y tu paz mental hoy mismo.
        </h2>

        <p className="text-xl text-stone-300 mb-12 max-w-2xl mx-auto" data-id="element-132">
          No permitas que el desorden te aísle de tus amigos y familiares nunca
          más. Obtén el sistema completo por menos de lo que cuesta una pizza.
        </p>

        <div className="bg-white rounded-3xl p-8 md:p-12 max-w-2xl mx-auto text-stone-900 shadow-2xl transform hover:scale-[1.02] transition-transform duration-300" data-id="element-133">
          <div className="uppercase tracking-widest text-sm font-bold text-orange-600 mb-4" data-id="element-134">
            Precio Especial de Lanzamiento
          </div>

          <div className="flex items-center justify-center items-baseline mb-8" data-id="element-135">
            <span className="text-3xl font-bold text-stone-400 line-through mr-4" data-id="element-136">
              $17
            </span>
            <span className="text-6xl font-black tracking-tight text-orange-600" data-id="element-137">
              $6.39
            </span>
            <span className="text-xl text-stone-500 ml-2" data-id="element-138">USD</span>
          </div>

          <Button size="xl" fullWidth className="text-sm sm:text-base mb-6 shadow-lg shadow-orange-500/30" onClick={() => window.open('https://pay.hotmart.com/H104735444I', '_blank')} data-id="element-139">
            ¡QUIERO MI COPIA DEL BLUEPRINT AHORA!
          </Button>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-stone-600 text-sm font-medium" data-id="element-140">
            <div className="flex items-center" data-id="element-141">
              <DownloadIcon className="w-5 h-5 mr-2 text-stone-400" data-id="element-142" />
              Acceso inmediato (PDF)
            </div>
            <div className="flex items-center" data-id="element-143">
              <ShieldCheckIcon className="w-5 h-5 mr-2 text-green-500" data-id="element-144" />
              Pago 100% Seguro
            </div>
          </div>
        </div>

        <p className="mt-8 text-stone-400 text-sm" data-id="element-145">
          Descarga el PDF y limpia tu casa hoy mismo.
        </p>
      </div>
    </section>;
}